import { render } from "./IosOpenInAppBanner.vue?vue&type=template&id=b8637bca"
import script from "./IosOpenInAppBanner.vue?vue&type=script&lang=js"
export * from "./IosOpenInAppBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__